<template>

      <v-form @submit.prevent="submitForm" ref="regForm" lazy-validation v-model="valid">


        <Donation/>
        <Review :form-total="formTotal.display"></Review>
        <v-card outlined v-if="formTotal.intVal > 0">

          <v-toolbar
              color="#488ba6"
              dark
              flat

          >
            <v-toolbar-title>Payment</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>

            <v-select
                prepend-icon="mdi-credit-card"
                :items="ccTypes"
                label="Credit Card Type"
                item-text="text"
                item-value="val"
                v-model="state.payment.cc.type"
                attach
                :rules="[v => !!v || 'Card Number is required']"
                required
            ></v-select>
            <v-text-field
                label="Credit Card Number"
                name="cc-number"
                prepend-icon="mdi-credit-card"
                type="text"
                v-model="state.payment.cc.number"
                :rules="[v => !!v || 'Card Number is required']"
                required
            ></v-text-field>

            <v-text-field
                label="Credit Card First Name"
                name="cc-first-name"
                prepend-icon="mdi-form-textbox"
                type="text"
                v-model="state.payment.cc.firstName"
                :rules="[v => !!v || 'Card first name is required']"
                required
            ></v-text-field>
            <v-text-field
                label="Credit Card Last Name"
                name="cc-last-name"
                prepend-icon="mdi-form-textbox"
                type="text"
                v-model="state.payment.cc.lastName"
                :rules="[v => !!v || 'Card last name is required']"
                required
            ></v-text-field>
            <v-text-field
                label="Expiry (Month/Year, 01/21)"
                name="cc-exp"
                prepend-icon="mdi-calendar-range"
                type="text"
                v-model="state.payment.cc.expiry"
                :rules="[v => !!v || 'Card expiry is required']"
                required
            ></v-text-field>
            <v-text-field
                label="CVV"
                name="cc-cvv"
                prepend-icon="mdi-credit-card-refund"
                type="text"
                v-model="state.payment.cc.cvv"
                :rules="[v => !!v || 'Card cvv is required']"
                required
            ></v-text-field>

          </v-card-text>


        </v-card>
        <v-card outlined class="mt-5">

          <v-toolbar
              color="#488ba6"
              dark
              flat

          >
            <v-toolbar-title>Terms and Conditions</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <p>
              Registration: <br>
              By registering for the FVS Annual Meeting, the attendee understands and agrees that attendee’s name, city,
              and state may be shared with other attendees and exhibitors. By allowing an exhibitor to scan the
              conference
              badge, attendee understands, agrees, and consents to the sharing of the attendee’s full contact
              information
              with the company sharing the badge. This includes mailing address, phone, and email. By registering for
              this
              Annual Meeting, I also give FVS the right to publish all photos, videos, etc. taken at this Conference.

            </p>
            <p>
              Cancellation Policy: <br>
              A written notice of cancellation must be received by {{ formattedCancellationCutoff }} to receive a
              refund.
              Cancellations
              received prior to this date will be honored minus a $100 administration fee. Refunds will not be honored
              after {{ formattedCancellationCutoff }}. Telephone cancellations cannot be accepted. Cancellation refunds
              will be processed
              within 30 days after the conclusion of the Conference.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#488ba6" class='align-right mr-2' style="color:white" @click="back">Edit Order</v-btn>

            <v-btn color="#488ba6" type="submit" style="color:white" :disabled="!valid">Register and Pay
              {{ formTotal.display }}
            </v-btn>
          </v-card-actions>

          <v-alert class="mt-2" type="error" v-if="this.state.payment.response.errorMsg">
            <small>{{ this.state.payment.response.errorMsg }} | Please refresh the page to try again.</small>

          </v-alert>
        </v-card>
      </v-form>

</template>

<script>

import {mapGetters} from 'vuex'
import Review from '@/components/Review'
import Donation from '@/components/Donation'

export default {
  name: "Form",
  data: function () {
    return {
      ccTypes: [
        {
          text: 'Visa',
          val: 'Visa'
        },
        {
          text: 'MasterCard',
          val: 'MC'
        },
        {
          text: 'American Express',
          val: 'AMEX'
        },
      ],
      valid: true,
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    formattedCancellationCutoff: function () {
      let options = {year: 'numeric', month: 'long', day: 'numeric'};
      let d = new Date(this.state.member.meeting.meetingInfo.start_date);
      d.setMonth(d.getMonth() - 1)
      return d.toLocaleDateString('en-US', options);
    }
  },
  methods: {
    submitForm: function () {

      if (this.$refs.regForm.validate()) {
        this.$store.dispatch('saveUpdateForm', this.formTotal.intVal);
      }


    },
    back: function () {
      this.$store.commit('continueUpdateRegForm', 'shop');
    }
  },
  props: [
    'formTotal'
  ],
  components: {
    Review,
    Donation
  }
}
</script>

<style scoped>

</style>